<atlas-location-list-item
    *ngFor="let location of locations"
    [location]="location"
    class="business-navbar__location-list-item"
    [isActive]="keyManager?.activeItem?.location === location"
></atlas-location-list-item>
